import axios from 'axios';
delete axios.defaults.headers.common['Accept'];
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.interceptors.request.use(function (config) {
	console.log('interceptors.request', config)
	return config;
}, function (error) {
	console.log('interceptors.request.error', error)
	return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
	console.log('interceptors.response', response)
	return response.data;
}, function (error) {
	console.log('interceptors.response.error', error)
	return Promise.reject(error);
});

export default axios;
